export function isValidDateString(dateString) {
    if (!dateString) return false

    // Check if the string matches the format MM/DD/YYYY
    const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/
    if (!dateRegex.test(dateString)) return false

    // Parse the date and check if it's valid
    const [month, day, year] = dateString.split('/').map(Number)
    const date = new Date(year, month - 1, day)
    if (date.getDate() !== day) return false
    return (
        date.getMonth() === month - 1 &&
        date.getDate() === day &&
        date.getFullYear() === year
    )
}

// Format Date Utility Function
export const formatDate = (dateStr) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' }
    return new Date(dateStr).toLocaleDateString(undefined, options)
}
